/**
 * The Player class acts as the view object for the player.
 */
const tbs_model_vo_MatchSuspensionReminder = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_MatchSuspensionReminder.prototype = {
    /* The view object name */
    name: '',
    /* The view object instance */
    view: {
        get: [
            {
                name: 'match',
                baseUrl: process.env.VUE_APP_PASS_API,
                apiPrefix: '/api/',
                service: 'GetBMMatchInfo.json',
                basePath: 'data.match',
                rule: {
                    id: 'id',
                    isSuspensionReminderOn: '$suspend',
                    suspensionYellowCardNum: 'yellowCardSuspend',
                    suspensionYellowCardGameNum: 'yellowCardSuspendTimes',
                    suspensionRedCardNum: 'redCardSuspend',
                    suspensionRedCardGameNum: 'redCardSuspendTimes',
                    isSuspensionLeadKnockout: '$suspendSpread'
                }
            },
            {
                name: 'match',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'getMatchNewsList',
                basePath: 'data',
                rule: {
                    suspensionReportNum: 'list.length'
                }
            },
        ],
        update: {
            name: 'match',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'AdminUpdateBMMatch',
                basePath: '',
                rule: {
                    id: 'id',
                    suspend: '$isSuspensionReminderOn',
                    yellowCardSuspend: 'suspensionYellowCardNum',
                    yellowCardSuspendTimes: 'suspensionYellowCardGameNum',
                    redCardSuspend: 'suspensionRedCardNum',
                    redCardSuspendTimes: 'suspensionRedCardGameNum',
                    suspendSpread: '$isSuspensionLeadKnockout'
                }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    formatSuspendSpread: function(isSuspensionLeadKnockout) {
        return isSuspensionLeadKnockout == true ? 1 : 0
    },
    renderIsSuspensionLeadKnockout: function(suspendSpread) {
        console.log('@renderIsSuspensionLeadKnockout', suspendSpread)
        return suspendSpread > 0
    },
    formatSuspend: function(isSuspensionReminderOn) {
        return isSuspensionReminderOn == true ? 1 : 0
    },
    renderIsSuspensionReminderOn: function(suspend) {
        return suspend > 0
    },
}

module.exports = tbs_model_vo_MatchSuspensionReminder